/*
 * Created by: cparaschiv
 * Date: 30.09.2013, 14:04
 */
(function () {

    var baseMappings = TS.domain.properties.DomainProperty.prototype.mapping;

    /**
     * @class TS.domain.properties.RepeaterProperty
     * @extends TS.domain.properties.DomainProperty
     * @classdesc A view model property that constructs a series of view models based on a data collection.
     * Each item in the collection acts as the data model ({@link TS.domain.Edit#Document Document}) for each inner view model.
     */
    TS.domain.properties.RepeaterProperty = new Class(
        /** @lends TS.domain.properties.RepeaterProperty# */
        {
            Extends: TS.domain.properties.DomainProperty,

            mapping: $.extend({}, baseMapping, {
                ignore: baseMapping.ignore.concat(['Domains']),
                copy: baseMapping.copy.concat(['JsModelClass']),
                suppress: baseMapping.suppress.concat(['JsModelClass'])
            }),

            initialize: function (domain, config) {
                var me = this;
                me.parent(domain, config);

                config.Domains && me.createDomains(config.Domains);
            },

            createDomain: function (config) {
                var me = this,
                    className = me.JsModelClass || 'TS.domain.RepeaterEditDomain',
                    ctor = TS.Util.getProperty(window, className),
                    parentDomain = me.Domain(),
                    rootUrl = config.rootUrl = config.rootUrl || TS.unwrap(parentDomain.rootUrl),
                    domain = new ctor(config);
                domain[TS.Constants.repeaterProp] = me;
                domain.ParentDomain = parentDomain;
                return domain;
            },

            createDomains: function (config) {
                var me = this,
                    domains = [];
                $.each(config, function (index, value) {
                    var domain = me.createDomain(value);
                    domains.push(domain);
                    domain.Document = ko.observable(me._dataSource()[index]);
                    domain.hookDocument && domain.hookDocument();
                });
                me.Domains = ko.observableArray(domains);
            },

            updateDomains: function (config) {
                var me = this,
                    newDomains = [],
                    oldDomains = me.Domains(),
                    findDomain = function (uid) {
                        var result;
                        $.each(oldDomains, function (index, value) {
                            if (value.modelUID === uid) {
                                result = value;
                                return false;
                            }
                        });
                        return result;
                    };
                $.each(oldDomains, function (name, value) {
                    value.disposable = true;
                });
                $.each(config, function (index, value) {
                    var domain = findDomain(value.modelUID),
                        document = me._dataSource()[index];
                    if (!domain) {
                        domain = me.createDomain(value);
                        domain.Document = ko.observable(document);
                        domain.hookDocument && domain.hookDocument();
                    } else {
                        delete domain.disposable;
                        domain.unhookDocument && domain.unhookDocument();
                        domain.Document(document);
                        domain.hookDocument && domain.hookDocument();
                    }
                    newDomains.push(domain);
                });
                $.each(oldDomains, function (name, value) {
                    if (value.disposable === true) {
                        value.unhookDocument && value.unhookDocument();
                        value.dispose();
                    }
                });
                me.Domains(newDomains);
            },

            hookDomain: function () {
                var me = this,
                    domain = me.Domain();

                me._dataSource = TS.Util.getProperty(domain, me.EditMember(), true); //skip unwrap, we need the observable to subscribe
                if (!me._dataSource) {
                    TS.Log.warn('Cannot find data source ' + me.EditMember() + ' for repeater ' + me.Name);
                    return;
                }
                me._dataSourceSubscription = me._dataSource.subscribe(me.onDataSourceChanged, me);
            },

            unhookDomain: function () {
                var me = this;
                me._dataSourceSubscription && me._dataSourceSubscription.dispose();
                me._dataSourceSubscription = null;
                me._dataSource = null;
            },

            onDataSourceChanged: function (newValue) {
                var me = this,
                    domain = me.Domain();
                //domain.submit();
            },

            _getData: function () {
                var me = this;
                return me.parent();
            },

            _setData: function (data) {
                var me = this;
                me.parent(data);
                data.Domains && me.updateDomains(data.Domains);
            },
        });

    TS.ObjectFactory.map('RepeaterProperty', TS.domain.properties.RepeaterProperty);
}());